var exports = {
  "K": "RecipientAddMessage.module__icon___ME1CQW",
};

module.exports = exports;
